import mock from 'src/utils/mock';
import { LetterHead as LetterHeadInterface } from 'src/types/letterHead';
const letterHead: LetterHeadInterface[] = [
    {
        E_Sign_ImageName: 'E_Sign_ImagePat',
        E_Sign_ImagePath: 'public\\uploads\\images\\letterHead\\E_Sign_ImagePath.jpg',
        LogoName: null,
        LogoPath: null,
        FreezeForSubLabs: ' ',
        Allow_Pri_LabHeader: ' ',
        AllowSubLabHeader: ' ',
        HeaderTagLine1: 'est',
        HeaderTagLine2: 'test2',
        Footer_Logo_Name: null,
        Footer_Logo_Path: null,
        LetterHeadID: 101,
    },
];

mock.onPost('/getAllLetterHead/').reply(function (config) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            // get parameters from post request
            resolve([200, letterHead]);
        }, 1000);
    });
});
